import React, { useEffect, useState } from "react";
import { GetGradeColour } from "../helpers/gradeHelper";
import { IGradeLozengeProps } from "../types/IGradeLozenge";
import styles from "./GradeLozenge.module.css";

export const GradeLozenge = (props: IGradeLozengeProps) => {
    const [fillColor, setFillColor] = useState<string>("");
    const [scoreColor, setScoreColor] = useState<string>("");

    useEffect(() => {
        setBackgroundColor(props.grade);
    }, [props]);

    const setBackgroundColor = (idwalGrade: number) => {
        const [scoreColor, fillColor] = GetGradeColour(idwalGrade);
        setScoreColor(scoreColor);
        setFillColor(fillColor);
    };

    const percentage: number = 100 - props.grade;

    return (
        <div className={styles.svgContainer}>
            <p
                data-testid="scoreText"
                style={{ color: scoreColor }}
                className={styles.scoreLabel}
            >
                {props.grade}
            </p>

            <svg width="140" height="32" viewBox="0 0 140 32">
                <defs>
                    <clipPath id="grade-bar-v2">
                        <path d="M133.886 0.000138681H6.11433C5.30987 -0.00526902 4.51236 0.147524 3.76808 0.449654C3.02381 0.751784 2.34761 1.19723 1.77876 1.76011C1.20992 2.32299 0.759759 2.99209 0.454428 3.72857C0.149097 4.46504 -0.00532485 5.2542 0.000140142 6.05022C0.000140142 9.47253 2.72105 13.9766 5.42261 21.4889C8.12417 29.0013 9.73979 32 13.104 32H133.886C135.506 31.9949 137.059 31.3556 138.204 30.2215C139.35 29.0875 139.996 27.5509 140 25.9475V6.05022C139.996 4.447 139.35 2.91069 138.204 1.77704C137.059 0.643385 135.506 0.00455964 133.886 0.000138681Z" />
                    </clipPath>
                </defs>
                <path
                    fill="lightgrey"
                    d="M133.886 0.000138681H6.11433C5.30987 -0.00526902 4.51236 0.147524 3.76808 0.449654C3.02381 0.751784 2.34761 1.19723 1.77876 1.76011C1.20992 2.32299 0.759759 2.99209 0.454428 3.72857C0.149097 4.46504 -0.00532485 5.2542 0.000140142 6.05022C0.000140142 9.47253 2.72105 13.9766 5.42261 21.4889C8.12417 29.0013 9.73979 32 13.104 32H133.886C135.506 31.9949 137.059 31.3556 138.204 30.2215C139.35 29.0875 139.996 27.5509 140 25.9475V6.05022C139.996 4.447 139.35 2.91069 138.204 1.77704C137.059 0.643385 135.506 0.00455964 133.886 0.000138681Z"
                />

                <g clipPath="url(#grade-bar-v2)">
                    <rect
                        data-testid="gradeLozengeFill"
                        className="progressMove"
                        id="progressMove"
                        style={{ fill: fillColor }}
                        x={percentage + "%"}
                        y="0%"
                        width="100%"
                        height="100%"
                    />
                </g>
            </svg>
        </div>
    );
};
